var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeTrackingMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.572,
    height: 18.572,
    viewBox: "0 0 18.572 18.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98436",
    "data-name": "Group 98436",
    transform: "translate(0.274 0.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26989",
    "data-name": "Group 26989",
    transform: "translate(-0.274 -0.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62598",
    "data-name": "Path 62598",
    d: "M9.286,18.572a9.286,9.286,0,1,1,9.286-9.286,9.3,9.3,0,0,1-9.286,9.286m0-17.024a7.738,7.738,0,1,0,7.738,7.738A7.747,7.747,0,0,0,9.286,1.548m3.869,7.738a.773.773,0,0,0-.774-.774H10.06V4.643a.774.774,0,0,0-1.548,0V9.286a.774.774,0,0,0,.774.774h3.1a.773.773,0,0,0,.774-.774",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeTrackingMenuIcon);
export default __webpack_public_path__ + "static/media/time-tracking-menu-icon.21b3706515754ec03a15cfdb0990270f.svg";
export { ForwardRef as ReactComponent };